module.exports = __webpack_public_path__ + "img/standard.2b5e4016.png";